import {createRoot, hydrateRoot} from 'react-dom/client';
import OurPhilosophy from '../pages/OurPhilosophy/OurPhilosophy'
import "../index.css";
import "../pages/OurPhilosophy/OurPhilosophy.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<OurPhilosophy {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <OurPhilosophy {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).OurPhilosophyVC = {mount, hydrate, unmount}